/*
|----------------------------------------------------------
|   Scripts to initialize:
|----------------------------------------------------------
|   Use this to add all scripts needed to be initialized
|   on every Pjax call.
|
*/
var siteURL = window.location.origin;

var scriptsToImport = [
        //WPB-3338
        siteURL + "/wp-content/plugins/onecms-emmis-audio-player/public/js/ll_mp_admin.js?ver=1.0.6",
        
        siteURL + "/wp-content/plugins/advertise/modules/ajax-reload-banners/js/common-banner-reload.js",
        siteURL + "/wp-content/plugins/advertise/modules/ajax-reload-banners/js/banner-reload.js",
        siteURL + "/wp-content/plugins/wpb-extended-show/frontend/js/extended-show-schedule_js_ajax.php",
        siteURL + "/wp-content/plugins/wpb-contest/js/jquery.cookie.js",
        siteURL + "/wp-content/plugins/wpb-contest/js/div_based_front.js",
        siteURL + "/wp-content/plugins/vipclub/js/sendpress.signup.js",
        siteURL + "/wp-content/plugins/wpb-super-gallery/public/inc/js/jquery.prettyPhoto.js",
        siteURL + "/wp-content/plugins/wpb-super-gallery/public/inc/js/image-gallery.js",
        siteURL + "/wp-content/plugins/wpb-super-gallery/public/inc/js/gallery.js",
        siteURL + "/wp-content/themes/037-itmwpb/inc/js/weatherwidget.js?ver=123",
        siteURL + "/wp-content/plugins/wpb-super-gallery/public/inc/js/jquery.flexslider.js",
        siteURL + "/wp-content/plugins/wpb-super-gallery/public/inc/js/wpb-slider.js",
        siteURL + "/wp-content/plugins/epic-social-share/assets/js/social-share.js",
        siteURL + "/wp-content/plugins/wpb-show-core/modules/jplayer/jquery.jplayer.js",
        siteURL + "/wp-content/plugins/wpb-better-audio-stats/js/wpb-jquery-jplayer.js",
        siteURL + "/wp-content/plugins/wpb-show-core/modules/jplayer/jquery.android-adapter-fix.js",
        siteURL + "/wp-content/plugins/wpb-show-core/modules/jplayer/jquery.jplayer-init-latest.js",
        siteURL + "/wp-content/plugins/wpb-ssl-podcast/public/js/wpb-ssl-podcast-public.js",
        siteURL + "/wp-content/plugins/wpb-ugc-v2/public/js/wpb-ugc-v2-public.js?dt=09_08_20&ver=2.1.0",
        // siteURL + "/wp-content/plugins/elementor-pro/assets/lib/sticky/jquery.sticky.min.js",
        "//widgets.listenlive.co/1.0/tdwidgets.min.js",
        "//vjs.zencdn.net/4.7.1/video.js",
    ];

    if("undefined"!=typeof eventPluginActive){
     if(eventPluginActive=='new'){
        scriptsToImport.push(  ...eventsJSArr
          //-----------------------------------------------------------------
          //new locations to above js files means plugin wise new custom changes js files.
          //-----------------------------------------------------------------
        ); 
     }else{
         scriptsToImport.push(
         siteURL + "/wp-content/plugins/events-calendar-pro/resources/tribe-events-pro.min.js?ver=3.6.1",
         siteURL + "/wp-content/plugins/events-calendar-pro/resources/widget-calendar.js?ver=3.9",
         siteURL + "/wp-content/plugins/the-events-calendar/resources/tribe-events-bar.min.js?ver=3.8",
         siteURL + "/wp-content/plugins/the-events-calendar/resources/tribe-events-ajax-list.min.js?ver=3.8",
         siteURL + "/wp-content/plugins/the-events-calendar/resources/tribe-events.min.js?ver=3.8",
         siteURL + "/wp-content/plugins/events-calendar-pro/resources/widget-countdown.js?ver=3.6.2",
        );
     }
    }
export default {
  scripts: scriptsToImport
}